import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";
import {
  IconButton,
  iconButtonVariants,
} from "@circleco/compass/components/IconButton";
import type { MenuOptions } from "@circleco/compass/components/Menu";
import { Menu } from "@circleco/compass/components/Menu";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";

export interface LogoMenuProps {
  children?: ReactNode;
  menuOptions?: MenuOptions;
}

export const LogoMenu = ({ children, menuOptions = [] }: LogoMenuProps) => {
  if (menuOptions.length === 0) {
    return <div className="flex items-center">{children}</div>;
  }

  const trigger = children ? (
    <button
      type="button"
      className="group inline-flex items-center gap-2 rounded-md focus-visible:shadow-focus focus-visible:outline-none"
      data-testid="community-menu"
      aria-label={t("user_menu_options")}
    >
      {children}
      <span
        aria-hidden
        className={classNames(
          iconButtonVariants({ variant: "ghost", size: "sm" }),
          "pointer-events-none",
          "group-hover:bg-hover group-hover:shadow-2xs group-hover:[--color-text-primary:var(--color-community-header-active-text)]",
          "group-active:bg-active group-active:shadow-2xs group-active:[--color-text-primary:var(--color-community-header-active-text)]",
          "group-data-[popup-open]:bg-active group-data-[popup-open]:shadow-2xs group-data-[popup-open]:[--color-text-primary:var(--color-community-header-active-text)]",
        )}
      >
        <Icon name="chevron-down" size="sm" />
      </span>
    </button>
  ) : (
    <IconButton
      icon="chevron-down"
      size="sm"
      variant="ghost"
      aria-label={t("user_menu_options")}
      data-testid="community-menu"
      data-header-icon-button
    />
  );

  return (
    <Menu
      align="start"
      side="bottom"
      options={menuOptions}
      data-testid="community-dropdown-menu"
      trigger={trigger}
    />
  );
};
